/* eslint-disable react/jsx-closing-tag-location */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

class TermsAndConditions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _agreeTermsAndConditions: false
        };
    }

    handleTermsConditionChange = (e) => {
        this.setState({
            _agreeTermsAndConditions: e.target.checked
        });
    }

    handleContinue = () => {
        this.props.handleBack();
        this.props.handleContinue();
    }

    TextForTermsAndConditions = () => {
        return (
            this.props.t('profile.terms_and_conditions', { first_name: this.props.currentUser.first_name, last_name: this.props.currentUser.last_name })
        );
    }

    render() {
        const { t } = this.props;
        return (
            <div className="demo-container mdl-grid">
                <div className="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone" />
                <div className="demo-content mdl-color--white mdl-shadow--4dp content mdl-color-text--grey-800 mdl-cell mdl-cell--8-col radius-20 min-250">
                    <div className="mdl-grid">
                        <div className="mdl-cell mdl-cell--12-col center-items">
                            <h4
                                className="text-center resume-heading"
                            >
                                {t('profile.heading_for_terms_conditions')}
                            </h4>
                        </div>
                    </div>
                    <div className="mdl-grid center-items">
                        <div className="mdl-cell mdl-cell--10-col ">
                            <FormControlLabel
                                className="text-left"
                                control={
                                    <Checkbox
                                        checked={this.state._agreeTermsAndConditions}
                                        color="primary"
                                        name="TermsAndCondition"
                                        onChange={this.handleTermsConditionChange}
                                    />
                                }
                                id="checkbox-top"
                                label={this.TextForTermsAndConditions()}
                            />
                            <div className="mdl-grid center-items">
                                <button
                                    className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                                    onClick={this.props.handleBack}
                                    type="button"
                                >
                                    {t('buttons.cancel')}
                                </button>
                                <button
                                    className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                                    disabled={!this.state._agreeTermsAndConditions}
                                    onClick={this.handleContinue}
                                    type="button"
                                >
                                    {t('buttons.agree_and_continue')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default withTranslation()(TermsAndConditions);
